import StrongOverallFit from '@images/strong-overall-fit.svg?react';
import GoodOverallFit from '@images/good-overall-fit.svg?react';
import FairOverallFit from '@images/fair-overall-fit.svg?react';
import WeakOverallFit from '@images/weak-overall-fit.svg?react';

export const OVERALL_FIT_DATA: { [key: number]: { icon: JSX.Element; title: string; color: string } } = {
  1: {
    icon: <StrongOverallFit data-testid="strong-fit" />,
    title: 'Strong overall fit',
    color: '#B4E326',
  },
  2: {
    icon: <GoodOverallFit data-testid="good-fit" />,
    title: 'Good overall fit',
    color: '#73C1FF',
  },
  3: {
    icon: <FairOverallFit data-testid="fair-fit" />,
    title: 'Fair overall fit',
    color: '#FFBEF6',
  },
  4: {
    icon: <WeakOverallFit data-testid="weak-fit" />,
    title: 'Weak overall fit',
    color: '#FFCD59',
  },
};
